import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { cmsContent } from '../cmsContent';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {},
    lng: 'it',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
  });

const DEFAULT_LANG = 'it' as const;

const STATIC_NAMESPACES = [
  'app',
  'contactPageModal',
  'error',
  'landingPage',
  'personalDetails',
  'contactDetails',
  'employmentDetails',
  'paymentDetails',
  'completion',
  'uploadPage',
  'link-expired',
  'step1',
  'summaryPage',
  'steps',
  'validation',
  'shoppingCart',
  'eSignPage',
  'dealerESignPage',
  'form',
  'legitimationPage',
  'esignSuccessPage',
  'esignFailedPage',
  'identificationTimeoutPage',
  'legitimationRefusedPage',
  'creditApprovedPage',
  'creditRefusedPage',
  'creditPendingPage',
  'navigationBlockedModal',
  'confirmDataModal',
] as const;

const CMS_NAMESPACES = ['faq', 'footer', 'links', 'consents'] as const;

type Namespace = typeof STATIC_NAMESPACES[number];
type CmsNamespace = typeof CMS_NAMESPACES[number];

export default async function loadResources(brandName: string) {
  const staticTranslationsPromise = Promise.all(
    STATIC_NAMESPACES.map(async (namespace: Namespace) => {
      const module = await import(`../../resources/base/content/${namespace}.json`);
      i18n.addResourceBundle(DEFAULT_LANG, namespace, module.default, true, true);
      /**
       * Request brand-specific resources and override (using deep) the
       * resources for specific brand. Make sure to chain those to avoid
       * race conditions.
       */
      import(`../../resources/${brandName}/content/${namespace}.json`)
        .then(contentModule => {
          i18n.addResourceBundle(DEFAULT_LANG, namespace, contentModule.default, true, true);
        })
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(() => {});
    })
  );

  const cmsTranslationsPromise = cmsContent()
    .then(cmsData => {
      CMS_NAMESPACES.forEach((namespace: CmsNamespace) => {
        if (cmsData[namespace]) {
          console.log(namespace, cmsData[namespace]);
          i18n.addResourceBundle(DEFAULT_LANG, namespace, cmsData[namespace], true, true);
        }
      });
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error('Failed to load CMS translations:', error);
    });

  await Promise.all([staticTranslationsPromise, cmsTranslationsPromise]);
}
